import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { EventComplete } from "../../models/events/event-complete.model";
import { EventDetailed } from "../../models/events/event-detailed.model";
import { WebBooking } from "../../models/event-bookings/web-booking.model";
import { EventBookingComplete } from "../../models/event-bookings/event-booking-complete.model";
import { Payment } from "../../models/payments/payment.model";
import { EventAttendee } from "../../models/events/event-attendees.model";
import { Update } from "@ngrx/entity";

export const EventActions = createActionGroup({
    source: 'Event Action',
    events: {
        "Load all upcoming events": emptyProps,
        "Load all events by system": props<{ systemRef: string }>(),
        "Load single event": props<{ eventRef: string, refresh: boolean}>(),
        "Get attendees": props<{ eventID: number}>(),
        "Book Event": props<{ booking: WebBooking }>()
    }
})

export const EventApiActions = createActionGroup({
    source: 'Event API',
    events: {
        "Fetch all upcoming events": props<{events: EventDetailed[]}>(),
        "Fetch all events by system": props<{events: EventDetailed[], systemRef: string}>(),
        "Fetch single event": props<{event: EventComplete}>(),
        "Confirm Event Booking": props<{ booking: EventBookingComplete }>(),
        "Confirm booking payment": props<{ payment: Payment}>(),
        "Confirm event payment": props<{ payment: Payment}>(),
        "Fetched attendees": props<{ update: Update<EventDetailed> }>(),
    }
})